import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { enumIncotermsType } from '@data-layer/enums/lcl/enumIncotermsType';
import { EnumHintKey } from '@data-layer/enums/common';
import { enumShippingRole } from '@data-layer/enums/user';

@Component({
  selector: 'lcl-incoterms-items',
  templateUrl: './lcl-incoterms-items.component.html',
  styleUrls: ['./lcl-incoterms-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclIncotermsItemsComponent implements OnInit {
  @Input() public incotermsControl: UntypedFormControl;
  @Input() public currentShippingRole: enumShippingRole = enumShippingRole.IMPORTER;
  @Input() public isHighlighted: boolean;
  @Output() public changeIncotermsSource: EventEmitter<enumIncotermsType> = new EventEmitter<enumIncotermsType>();

  public enumIncotermsType: typeof enumIncotermsType = enumIncotermsType;
  public enumHintKey: typeof EnumHintKey = EnumHintKey;

  private otherShippingRoles: enumShippingRole[] = [enumShippingRole.OTHER, enumShippingRole.AGENT];

  constructor() {}

  public ngOnInit(): void {
    this.incotermsControl.valueChanges.subscribe((value: enumIncotermsType) => {
      this.changeIncotermsSource.emit(value);
    });
  }

  public get isImporter(): boolean {
    return this.currentShippingRole === enumShippingRole.IMPORTER;
  }

  public get isShipper(): boolean {
    return this.currentShippingRole === enumShippingRole.SHIPPER;
  }

  public get isOther(): boolean {
    return this.otherShippingRoles.includes(this.currentShippingRole);
  }
}
